import GoIconShow from "./go-icon-sel/components/IconShow.vue";
import GoImgShow from "./go-img-sel/components/ImgShow.vue";

import GoIconSel from "./go-icon-sel/index.vue";
import GoImgSelCtl from "./go-img-sel/img-sel-ctl.vue";
import GoIconSelCtl from "./go-icon-sel/icon-sel-ctl.vue";
import GoImgSel from "./go-img-sel/index.vue";
import GoControlSel from "./go-control-sel/index.vue";
import GoHerTree from "./go-her-tree/index.vue";
import GoVerTree from "./go-ver-tree/index.vue";


export default {
    GoIconShow,
    GoImgShow,
    GoIconSel,
    GoImgSel,
    GoControlSel,
    GoImgSelCtl,
    GoIconSelCtl,
    GoHerTree,
    GoVerTree
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/pageVue/index.js